/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../core/IceEntity';
import { provider_reference } from '../domain/provider_reference';
import { IceTypes } from '../icetypes';

export class encounter extends IceEntity {
  encounter_key: string = "";
  patient_room_num: string = "";
  patient_bed_num: string = "";
  patient_case_key: string = "";
  rto_type: number = IceTypes.ReturnToOffice.rto1_2Days.value;
  signature: string = "";
  signature_date: any = NaN;
  doctor_signature: string = "";
  other_instruction: string = "";
  cfield_data: string = "";
  subscriber_key: string = "";

  appointment_key: string = "";
  patient_trans_account: string = "";
  trans_account: string = "";
  account_type = IceTypes.ACCOUNT_TYPE.actNone;
  recurrence_key: string = "";
  referral_from_key: string = "";
  appointment_status = IceTypes.appt_status.apptstatNone;
  appointment_status_note: string = "";
  appointment_type = IceTypes.appt_type.appttypeInitial;
  time_slot_start: any = NaN;
  time_slot_end: any = NaN;
  interval_type = IceTypes.interval.interval15;
  slot_color: string = "";
  slot_font_color: string = "";
  multiple = false;
  subject: string = "";
  txt: string = "";
  reminder_key: string = "";
  record_version = 0;
  offline_record_status = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";
  telehealth = false;

  PROVS: provider_reference[] = [];

  gettablename(): string {
    return "ENCOUNTER";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "PROVS") return true;
    else if (ColumnName == "USERS") return true;
    else if (ColumnName == "TASKS") return true;
    else if (ColumnName == "FORMS") return true;
    else if (ColumnName == "NOTES") return true;
    else if (ColumnName == "BILLS") return true;
    else if (ColumnName == "DIAGS") return true;
    else if (ColumnName == "CPOES") return true;
    else if (ColumnName == "EDOCS") return true;
    else if (ColumnName == "GLRULES") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "PROVS") return "PROVIDER_REFERENCE";
    else if (ColumnName == "USERS") return "USER_TRANS_ACCOUNT";
    else if (ColumnName == "TASKS") return "TASK_REFERENCE";
    else if (ColumnName == "FORMS") return "MISCELLANEOUS_FORM_REFERENCE"; // To do add
    else if (ColumnName == "NOTES") return "ENCOUNTER_PROGRESS_NOTES_REFERENCE";
    else if (ColumnName == "BILLS") return "SUPERBILL_CHARGES_REFERENCE"; // To do add
    else if (ColumnName == "DIAGS") return "DIAGNOSIS_REFERENCE";
    else if (ColumnName == "CPOES") return "CPOE_REFERENCE"; // To do add 
    else if (ColumnName == "EDOCS") return "EXTERNAL_DATA_REFERENCE";
    else if (ColumnName == "GLRULES") return "MANAGEMENT_GUIDELINE";

    return null;
  }
}
